import React, { useEffect, useState } from 'react'
import GeneralLogic from '../../functions/logic/general'
import { useSnackbar } from 'notistack'

export default function BodegaForm(props) {
    const [nombre, setNombre] = useState('')
    const [ubicacion, setUbicacion] = useState('')
    const [tipo, setTipo] = useState('')
    const [codigo, setCodigo] = useState('')
    const [tipoData, setTipoData] = useState([])
    const [estado, setEstado] = useState('')
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')

    useEffect(() => {
        getTipos()
        const nombreLS = localStorage.getItem("nombre")
        const ubicacionLS = localStorage.getItem("ubicacion")
        const tipoLS = localStorage.getItem("tipo")
        const estadoLS = localStorage.getItem("estado")
        const codigoLS = localStorage.getItem("codigo")
    
        if (nombreLS || ubicacionLS || tipoLS || estadoLS || codigoLS) {
            setNombre(nombreLS || '')
            setUbicacion(ubicacionLS || '')
            setTipo(tipoLS || '')
            setEstado(estadoLS || '')
            setCodigo(codigoLS || '')
        } else if (props.formData) {
            const datForm = props.formData
            setNombre(datForm["Nombre"] || '')
            setUbicacion(datForm["Ubicacion"] || '')
            setTipo(datForm["TipoId"] || '')
            setEstado(datForm["estadoNemo"] || '')
            setCodigo(datForm["Codigo"] || '')
        }
    }, [props])
    

    const getTipos = async () => {
        const response = await GeneralLogic.getTipoBodegaLogic(userToken)
        if (!response.error) {
            setTipoData(response.data)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
    }

    return (
        <>
            <div className="card card-primary card-outline card-tabs">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Código <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    id="codigo"
                                    name="codigo"
                                    maxLength={100}
                                    value={codigo}
                                    onChange={e => {
                                        localStorage.setItem('codigo', e.target.value)
                                        setCodigo(localStorage.getItem("codigo"))
                                    }}
                                    disabled={props.formData["Codigo"] ? "disabled" : ""}
                                    className="form-control"
                                    placeholder="Ingresar SKU"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Nombre <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    maxLength={100}
                                    value={nombre}
                                    onChange={e => {
                                        localStorage.setItem('nombre', e.target.value)
                                        setNombre(localStorage.getItem("nombre"))
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar SKU"
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Ubicación <span style={{ color: "red" }}>*</span></label>
                                <input
                                    id="ubicacion"
                                    name="ubicacion"
                                    type="text"
                                    maxLength={100}
                                    value={ubicacion}
                                    onChange={e => {
                                        localStorage.setItem('ubicacion', e.target.value)
                                        setUbicacion(localStorage.getItem("ubicacion"))
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar ubicación"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="form-label fw-bold">Tipo <span style={{ color: "red" }}>*</span></label>
                                <select id="tipo" value={tipo}
                                    onChange={e => {
                                        localStorage.setItem('tipo', e.target.value)
                                        setTipo(localStorage.getItem("tipo"))
                                    }}
                                    name="tipo" className="form-control" aria-label="Select 1">
                                    <option value="">Selecciona Tipo </option>
                                    {tipoData.map((tipo) => (
                                        <option key={tipo.nemonico} value={tipo.nemonico}>
                                            {tipo.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="form-label fw-bold">Estado <span style={{ color: "red" }}>*</span></label>
                                <select id="estado" value={estado}
                                    onChange={e => {
                                        localStorage.setItem('estado', e.target.value)
                                        setEstado(localStorage.getItem("estado"))
                                    }}
                                    name="estado" className="form-control" aria-label="Select 1">
                                    <option value="">Selecciona estado </option>
                                    <option value="CONFIGH0002">Activo</option>
                                    <option value="CONFIGH0003">Inactivo</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
